/**
 * Special service schedules that replace regular service times on the home page.
 * Add new entries for holiday periods (Holy Week, Christmas, etc.).
 * The active schedule is determined by whether today's date falls within the date range.
 */
export const specialSchedules = [
	{
		title: 'Avak Shapat — Great Week Services',
		startDate: '2026-03-29',
		endDate: '2026-04-05',
		days: [
			{
				date: '2026-03-29',
				name: '"Dzaghgazart" Palm Sunday',
				subtitle: "Christ's Triumphant and Glorious Entry into Holy Jerusalem",
				services: [
					{ name: '"Soorp Badarak" Holy Liturgy', time: '10:00 am' },
					{ name: '"Tmpatzek", The Opening of the Gates of Paradise Ceremony', time: '12:00 pm' },
					{ name: 'St. Thomas Annual Anniversary Dinner', time: '1:00 pm' },
				],
			},
			{
				date: '2026-04-02',
				name: '"Avak Hinkshaptí" Great Thursday',
				services: [
					{ name: '"Soorp Badarak" Holy Liturgy', time: '10:00 am' },
					{ name: '"Vodnluva" The Washing of the Feet Ceremony', time: '7:15 pm' },
					{ name: 'Light Fellowship Dinner', time: '8:15 pm' },
					{
						name: '"Khavaroom" Remembrance of the Last Supper, Betrayal and the Passion of Christ',
						time: '9:30 pm',
					},
				],
			},
			{
				date: '2026-04-03',
				name: '"Avak Oorpat" Great Friday',
				services: [
					{ name: '"Taghoum", The Entombment of Our Lord Jesus Christ', time: '7:15 pm' },
				],
			},
			{
				date: '2026-04-04',
				name: '"Avak Shapat" Great Saturday',
				services: [
					{ name: 'Communion and Breakfast for Children', time: '9:15 am' },
					{ name: '"Djurakalootz" Easter Eve Services — Bible Readings', time: '4:00 pm' },
					{ name: '"Soorp Badarak" Holy Liturgy', time: '4:30 pm' },
				],
			},
			{
				date: '2026-04-05',
				name: '"Soorp Zadig" HOLY EASTER',
				subtitle: 'The Triumphant Resurrection of Our Lord and God Jesus Christ',
				services: [
					{
						name: '"Soorp Badarak" Holy Liturgy / "Antasdan" The Blessing of the Four Corners of the World Ceremony',
						time: '10:00 am',
					},
				],
			},
		],
	},
];

/**
 * Returns the active special schedule for today, or null if none.
 */
export function getActiveSchedule() {
	const now = new Date();
	const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
	return specialSchedules.find((s) => today >= s.startDate && today <= s.endDate) ?? null;
}
